module.exports = __webpack_public_path__ + "img/1-5.a5c7aea0.svg";